import React, { useState, useEffect } from 'react'

// ── Intro Modal ───────────────────────────────────────────
export default function IntroModal({ intro, onRefresh, onChange, onClose }) {
  const [localIntro, setLocalIntro] = useState(intro?.text || '')
  const [localSubject, setLocalSubject] = useState(intro?.subject || '')
  const loading = intro?.loading

  useEffect(() => {
    setLocalIntro(intro?.text || '')
    setLocalSubject(intro?.subject || '')
  }, [intro?.text, intro?.subject])

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600 }}>
        <div className="modal-header">
          <h2 className="modal-title">Intro & Subject Line</h2>
          <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
            <button className="btn-secondary" onClick={onRefresh} disabled={loading}>
              {loading ? 'Generating…' : '↺ Regenerate'}
            </button>
            <button className="modal-close" onClick={onClose}>✕</button>
          </div>
        </div>
        {loading ? (
          <div className="loading-state" style={{ padding: '2rem' }}>
            <div className="loading-spinner" /><p>Generating…</p>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '1rem' }}>
              <label className="editor-label">Email subject line</label>
              <input className="editor-input" value={localSubject}
                onChange={e => { setLocalSubject(e.target.value); onChange('subject', e.target.value) }}
                placeholder="" />
            </div>
            <div>
              <label className="editor-label">Opening paragraph <span style={{ color: '#767676', fontWeight: 400 }}>(60 words max)</span></label>
              <textarea className="editor-input" value={localIntro}
                onChange={e => { setLocalIntro(e.target.value); onChange('text', e.target.value) }}
                rows={5} style={{ resize: 'vertical', fontStyle: 'italic' }} placeholder="" />
              <p style={{ fontFamily: 'var(--font-mono)', fontSize: 'calc(0.65rem * 1.2)', color: '#767676', marginTop: '0.3rem' }}>
                {localIntro.trim().split(/\s+/).filter(Boolean).length} / 60 words
              </p>
            </div>
          </>
        )}
        <div className="modal-actions">
          <button className="btn-primary" onClick={onClose}>Save & close</button>
        </div>
      </div>
    </div>
  )
}
